import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useState, useEffect } from 'react';
import { countryCodeJson } from './countryCode';
import 'bootstrap/dist/css/bootstrap.min.css';
import './projectEnquiryForm.css';
import { FirestoreService } from '../../services/firestoreService';
import ContactService from '../../services/contactService/contactService';

function ProjectEnquiryForm () {
  /* contact retrival starts */
    const [contacts, setContacts] = useState();
    const contactsCollection = '/contacts';
    const contactService = new ContactService(contactsCollection); // nosql database service
    const fetchContact = async ()=> {
    const id = 'doge-algorithm';
    const data = await contactService.getDataById(id);
    setContacts(data)
   }
   useEffect(() => {
    fetchContact();
   }, [])
     /* contact retrival ends */
  const projectCollection = '/project_enquiry';
  const firestoreService = new FirestoreService(projectCollection); // nosql database service
  /*********************** Hooks varaiables start here*************************/
  const [name, setName] = useState(''); // Name hook
  const [email, setEmail] = useState(''); // email hook
  const [code, setCode] = useState(''); // country code hook
  const [phone, setPhone] = useState(''); // phone hook
  const [checkedAI, setCheckedAI] = useState(false); // AI hook
  const [checkedFullStack, setCheckedFullStack] = useState(false); // Full Stack hook
  const [checkedFrontEnd, setCheckedFrontEnd] = useState(false); // Front End hook
  const [checkedBackEnd, setCheckedBackEnd] = useState(false); // Back End hook
  const [other, setOther] = useState(''); // other hook
  /************************ Hooks varaiables end here**************************/

  /******************Hooks functions start here********************************/
  const nameChange = (event) => {
     setName(event.target.value );
   };// Name hook function
   const emailChange = (event) => {
      setEmail(event.target.value );
    };// Email hook function
  const codeChange = (event) => {
    setCode(event.target.value);
  }; // country code hook function
  const phoneChange = (event) => {
     setPhone(event.target.value );
   };
  const countryCodeTag = countryCodeJson.map((data, key) =>
  <MenuItem value={data.code + data.dial_code}>{data.code + data.dial_code}</MenuItem>
); // country code function that maps json data to MenuItem tag
  const checkChangeAI = (event) => {
    setCheckedAI(event.target.checked);
  };// SDN hook function
  const checkChangeFullStack = (event) => {
    setCheckedFullStack(event.target.checked);
  };// ICN hook function
  const checkChangeFrontEnd = (event) => {
    setCheckedFrontEnd(event.target.checked);
  };// Data hook function
  const checkChangeBackEnd = (event) => {
    setCheckedBackEnd(event.target.checked);
  };// ML hook function
  const otherChange = (event) => {
    setOther(event.target.value);
  }; // Other hook function
  const submitClick = async () => {
    const data = {
      'name' : name.trim(),
      'email' : email.trim(),
      'country_code' : code.trim(),
      'phone' : phone.trim(),
      'ai' : checkedAI.toString(),
      'fullstack' : checkedFullStack.toString(),
      'frontend' : checkedFrontEnd.toString(),
      'backend' : checkedBackEnd.toString(),
      'other' : other.trim(),
      'date_time' : new Date()
    }
    if((!data.name && !data.email)){
      window.alert('Name and Email are required')
      return;
    }
    if((!data.name)){
      window.alert('Name is required')
      return;
    }
    if((!data.email)){
      window.alert('Email is required')
      return;
    }
    await firestoreService.addData(data);
    window.location.reload();
   };

  return (
  <div className="ProjectEnquiryForm">
  <span>
  <h2 className="ProjectEnquiryForm-Header">Say your requirement to us , We will help you</h2>
  &nbsp;
  </span>
  {/* <span>
    <InputLabel className="ProjectEnquiryForm-Element" id="check-data-label">Interested in Front End Development <br/> ( Angular/ReactJS )
    <Checkbox
      checked={checkedFrontEnd}
      onChange={checkChangeFrontEnd}
      inputProps={{ 'aria-label': 'primary checkbox' }}/></InputLabel>
  </span>
  <span>
    <InputLabel className="ProjectEnquiryForm-Element" id="check-data-label">Interested in Back End Development <br/> ( NodeJS/Flask/Django/MySQL/PostgreSQL/MongoDB )
    <Checkbox
      checked={checkedBackEnd}
      onChange={checkChangeBackEnd}
      inputProps={{ 'aria-label': 'primary checkbox' }}/></InputLabel>
  </span>
  <span>
    <InputLabel className="ProjectEnquiryForm-Element" id="check-data-label">Interested in Full Stack Development <br/> ( MEAN stack/MERN stack )
    <Checkbox
      checked={checkedFullStack}
      onChange={checkChangeFullStack}
      inputProps={{ 'aria-label': 'primary checkbox' }}/></InputLabel>
  </span>
  <span>
  <InputLabel className="ProjectEnquiryForm-Element" id="check-ml-label">Interested in Artificial Intelligence <br/> ( Data Science/Data Analytics/Machine Learning/Deep Learning ) 
  <Checkbox
    checked={checkedAI}
    onChange={checkChangeAI}
    inputProps={{ 'aria-label': 'primary checkbox' }}/></InputLabel>
   </span> */}
  <span>
  <TextField
  color="secondary"
  label="Name*"
  variant="outlined"
  value={name}
  onChange={nameChange}
  className="ProjectEnquiryForm-Element"/></span>
  <span><TextField
  color="secondary"
  label="E-mail*" type="email" variant="outlined"
  value={email} onChange={emailChange}
  className="ProjectEnquiryForm-Element"/></span>
  <span>
    <InputLabel id="select-label">Code</InputLabel>
        <Select
          className="ProjectEnquiryForm-Select"
          labelId="demo-simple-select-label"
          id="select-code"
          value={code}
          onChange={codeChange}>
          {countryCodeTag}
        </Select>
        <TextField
        color="secondary"
        label="Phone"  variant="outlined"
        value={phone} onChange={phoneChange}
        id="ProjectEnquiryForm-Phone"/></span>
  {/* <span>
   <InputLabel className="ProjectEnquiryForm-Element" id="check-sdn-label">I need SDN based Solution
   <Checkbox
     checked={checkedSDN}
     onChange={checkChangeSDN}
     inputProps={{ 'aria-label': 'primary checkbox' }}/></InputLabel>
</span>
<span>
 <InputLabel className="ProjectEnquiryForm-Element" id="check-icn-label">I need ICN based Solution
 <Checkbox
   checked={checkedICN}
   onChange={checkChangeICN}
   inputProps={{ 'aria-label': 'primary checkbox' }}/></InputLabel>
</span> */}
   <span>
   <TextField
   color="secondary"
   label="Type your doubts and queries here!" type="text" variant="outlined"
   value={other}
   onChange={otherChange}
   className="ProjectEnquiryForm-Element"/>
   </span>
  <span>
  <Button variant="outlined"
   onClick={submitClick}
   color="secondary"
   className="ProjectEnquiryForm-ButtonSubmit">Submit</Button>
   </span>
   <br/>
   <address>
   {/* https://stackoverflow.com/questions/17711146/how-to-open-link-in-a-new-tab-in-html */}   
   Mail to us
    <br/>
  Email: <a href={"mailto:"+contacts?.email+"?subject=Mail from dogealgo"} target="_blank" rel="noopener noreferrer" > {contacts?.email} </a>
  <br/>
  <br/>
  Connect with us
  <br/>
  LinkedIn: <a href={contacts?.linkedin} target="_blank" rel="noopener noreferrer"> {contacts?.linkedin} </a>
  <br/>
  Instagram: <a href={contacts?.instagram} target="_blank" rel="noopener noreferrer"> {contacts?.instagram} </a>
  </address>
  </div>
  );
}
export default ProjectEnquiryForm;
